/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import { Checkbox, Flex, Form, Typography } from 'antd';
import { ProcedureStage } from '../../generated/graphql';
import Gutter from '../layout/Gutter';

interface LearningOptionsProps {
  isAnswered: boolean;
  isALCEnabled: boolean;
  questionValues: any;
  onValuesChange: (values: Partial<any>) => void;
  procedure?: any;
  worker?: any;
}

const LearningOptions: React.FC<LearningOptionsProps> = ({
  isAnswered,
  isALCEnabled,
  questionValues,
  onValuesChange,
  procedure,
  worker
}) => {
  return (
    <>
      {!isAnswered && (
        <Form.Item name="remember" valuePropName="checked">
          <Checkbox
            disabled={isAnswered}
            data-cy="remember-checkbox"
            data-testid="remember-checkbox"
          >
            {procedure
              ? 'Always use this answer for this process'
              : 'Always use this answer for this department'}
          </Checkbox>
        </Form.Item>
      )}

      {isALCEnabled &&
        procedure?.id &&
        !isAnswered &&
        questionValues?.remember && (
          <>
            <Gutter size={2} direction="vertical" />
            <Typography.Text>Apply learning in</Typography.Text>
            <Gutter size={0.5} direction="vertical" />
            <Flex gap={16}>
              <Form.Item>
                <Checkbox
                  disabled={
                    isAnswered || worker?.stage === ProcedureStage.Draft
                  }
                  data-cy="draft-mode-checkbox"
                  data-testid="draft-mode-checkbox"
                  checked={questionValues?.draft}
                  onChange={(e) =>
                    onValuesChange({
                      draft: e.target.checked
                    })
                  }
                >
                  Draft Mode
                </Checkbox>
              </Form.Item>
              <Form.Item>
                <Checkbox
                  disabled={
                    isAnswered ||
                    worker?.stage === ProcedureStage.Published ||
                    !worker?.stage
                  }
                  data-cy="publish-mode-checkbox"
                  data-testid="publish-mode-checkbox"
                  checked={questionValues?.published}
                  onChange={(e) =>
                    onValuesChange({
                      published: e.target.checked
                    })
                  }
                >
                  Published Mode
                </Checkbox>
              </Form.Item>
            </Flex>
            <Gutter size={0.5} direction="vertical" />
            <Typography.Text type="secondary">
              Note: The learning will be applied to the current published
              process, effective immediately.
            </Typography.Text>
          </>
        )}
    </>
  );
};

export default LearningOptions;
